import { userHasPermission } from "@/auth/permissions";
import { useUser } from "@/hooks/useAuth";

export function useHasPermission(permission: string): boolean {
  return userHasPermission(useUser(), permission);
}

export function useHasAnyPermission(permissions: string[]): boolean {
  const user = useUser();
  return permissions.some((p) => userHasPermission(user, p));
}
